import Box from 'carbon-react/esm/components/box';
import { Tabs, Tab } from 'carbon-react/esm/components/tabs';
import UserInfosTab from './userInfosTab';
import RegisterTab from './registerTab';
import { User } from '@auth0/auth0-react';
import { AccountTabEnum } from '../constants/account.constants';
import { useResponsive } from '../../../hooks/useResponsive';
import { Typography } from 'carbon-react/esm/components/typography/__internal__/__next__/typography.component';
import styled from 'styled-components';

const AccountTabsContainer = styled.div`
  width: 100%;

  &[data-orientation='vertical'] [data-component='tab-list'] {
    margin-right: 0;
  }

  &[data-orientation='vertical'] [data-component='tab-panel'] {
    padding: 0;
  }
`;

const AccountComponent = ({ user, selectedTab }: { user: User; selectedTab?: AccountTabEnum }) => {
  const tabId = selectedTab ?? `${AccountTabEnum.User}`;
  const { isDesktopOrLarger, isMobile } = useResponsive();

  return (
    <Box
      pr={isDesktopOrLarger ? 40 : 0}
      pl={isDesktopOrLarger ? 40 : 0}
      border-radius="borderRadius000"
    >
      <Box pt={24} pb={24} pl={16} pr={16} border-radius="var(--borderRadius000)">
        <Typography variant="h1">Mon compte</Typography>
      </Box>

      <Box bg="#f2f5f6" display="flex" width="100%">
        <AccountTabsContainer data-orientation={isDesktopOrLarger ? 'vertical' : 'horizontal'}>
          <Tabs
            position={isDesktopOrLarger ? 'left' : 'top'}
            size={isMobile ? 'default' : 'large'}
            selectedTabId={tabId}
          >
            <Tab label="Paramètres" id={`${AccountTabEnum.User}`} key="tab-1">
              <UserInfosTab user={user} />
            </Tab>
            <Tab id={`${AccountTabEnum.Register}`} label="Référencement" key="tab-2">
              <RegisterTab />
            </Tab>
          </Tabs>
        </AccountTabsContainer>
      </Box>
    </Box>
  );
};

export default AccountComponent;
